import { Divider } from 'antd'
import CantileverRow from 'components/CantileverRow'
import React from 'react'
import styled from 'styled-components'

const LeadingContentContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const StyledDivider = styled(Divider)`
  height: 1.075rem;
  margin-top: 0.1875rem;
`

const StyledTitle = styled.h1`
  cursor: default;
`

export const PageHeader: React.FC<{
  title?: string
  titleContent?: React.ReactNode
  subtitle?: string
  icon?: React.ReactNode
  trailingContent?: React.ReactNode
}> = ({ title, titleContent, subtitle, icon, trailingContent }) => (
  <CantileverRow
    pageTitle
    leadingContent={
      <LeadingContentContainer>
        {icon && <span>{icon}</span>}
        {titleContent ? (
          <>{titleContent}</>
        ) : (
          <StyledTitle>{title}</StyledTitle>
        )}
        {subtitle && (
          <>
            <StyledDivider orientation='vertical' />
            <StyledTitle>{subtitle}</StyledTitle>
          </>
        )}
      </LeadingContentContainer>
    }
    trailingContent={trailingContent}
  />
)
